// Libs
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Container, Row, Col } from "../../components/Elemental";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";

// CSS
import "./styles.scss";

// Components/Containers
import Button from "../../components/Button";
import Form from "../../components/Form";
import Input from "../../components/Input";

// Validate
import * as validate from "../../constants/validate";

// Actions
import { resetPassword } from "./actions";
import { changeErr } from "../App/actions";
import Warning from "../Warning";

class RedefinePasswordPage extends Component {
  componentDidMount() {
    this.props.changeErr(null);

    const token = this.props.match.params.token;
    if (!token) {
      this.props.history.push('/login')
    }
  }

  handleFormSubmit = (reduxFormData) => {
    const { resetPassword, history } = this.props;
    const token = this.props.match.params.token;

    const data = {
      token,
      newPassword: reduxFormData.newPassword,
    };

    resetPassword(data)
      .then(() => {
        setTimeout(() => {
          history.push("/login");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error resetting password:", error);
      });
  };

  render() {
    const { localLoading, handleSubmit, error, success } = this.props;
    const { handleFormSubmit } = this;

    return (
      <div className="redefine-password-page">
        <Container className="redefine-password-page__container">
          <div className="redefine-password-page__content">
            <h1 className="redefine-password-page__title">Redefinir Senha</h1>
            <p className="redefine-password-page__text">
              Digite sua nova senha abaixo.
            </p>
            <Form onSubmit={handleSubmit(handleFormSubmit)}>
              <Row>
                <Col>
                  <Field
                    component={Input}
                    name="newPassword"
                    type="password"
                    label="Nova Senha"
                    gutter={15}
                    validate={validate.validatePassword}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field
                    component={Input}
                    name="confirmPassword"
                    type="password"
                    label="Confirmar Nova Senha"
                    gutter={15}
                    validate={validate.validatePassword}
                  />
                </Col>
              </Row>
              <Warning gutter={30} align="center" success={success} err={error} />
              <Button type="submit" localLoading={localLoading} gutterTop={30}>
                Redefinir Senha
              </Button>
              <NavLink to="/login">
                <Button gutterTop={15}>Voltar para Login</Button>
              </NavLink>
            </Form>
          </div>
        </Container>
      </div>
    );
  }
}

const reduxFormValidate = (values) => {
  const errors = {};

  if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = "Senhas não coincidem.";
  }

  if (
    ["semprocesso", "sem processo", "com acordo", "comacordo"].indexOf(
      values.newPassword?.toLowerCase()
    ) !== -1
  ) {
    errors.newPassword = "Senha inválida por questões de segurança.";
  }

  return errors;
};

RedefinePasswordPage = reduxForm({
  form: "redefinePassword",
  validate: reduxFormValidate,
})(RedefinePasswordPage);

RedefinePasswordPage = connect(
  (state, ownProps) => ({
    localLoading: state.app.localLoading,
    success: state.app.success,
    error: state.app.err,
  }),
  { resetPassword, changeErr }
)(RedefinePasswordPage);

export default RedefinePasswordPage;
